
import React, { useEffect, useRef, useState } from 'react';
import ChartPublico from './ChartPublico';
import ModalSoborno from './ModalSoborno';
import ConfirmationDialog from './ConfirmationDialog';
import { ReactComponent as CallIcon } from '../assets/icons/call.svg';
import { ReactComponent as PublicIcon } from '../assets/icons/public.svg';
import { ReactComponent as FiftyIcon } from '../assets/icons/fifty.svg';
import WizardMagoIcon from '../assets/icons/wizard-mago.jsx';
import { FaPause, FaPlay, FaRotateRight, FaPhoneSlash } from 'react-icons/fa6';
import buildImageUrl from '../config/imageUrlHelper';

// SVG prohibido (inline)
function ProhibidoSVG() {
  return (
    <svg width="48" height="48" viewBox="0 0 128 128" style={{position:'absolute',top:0,left:0,right:0,margin:'auto',zIndex:10,pointerEvents:'none'}}>
      <path d="M64 4C30.9 4 4 30.9 4 64s26.9 60 60 60s60-26.9 60-60S97.1 4 64 4zm50 60c0 12-4.2 23-11.3 31.6L32.4 25.3C41 18.2 52 14 64 14c27.6 0 50 22.4 50 50zM14 64c0-12 4.2-23 11.3-31.6l70.3 70.3C87 109.8 76 114 64 114c-27.6 0-50-22.4-50-50z" fill="#c33"></path>
      <path d="M60.1 7C47 7 35 11.5 25.4 19l-.1-.1l-1.1 1.1C11.9 30.3 4 45.8 4 63.1c0 31 25.1 56.1 56.1 56.1s56.1-25.1 56.1-56.1S91.1 7 60.1 7zM32.4 25.3C41 18.2 52 14 64 14c27.6 0 50 22.4 50 50c0 12-4.2 23-11.3 31.6l-70.6-70l.3-.3zM14 64c0-11.8 4.1-22.7 11-31.2l70.6 69.9C87 109.8 76 114 64 114c-27.6 0-50-22.4-50-50z" fill="#f44336"></path>
      <path d="M45 10.9c1.7-.4 4.2-1.6 5.9-1.1c1 .3 1.9 1.5 1.5 2.5c-.3.8-1.1 1.3-2 1.5c-4.1 1.1-7.7 2.3-11.3 4.1C32 21.6 25.6 27.2 21 33.7c-1.9 2.7-3.4 5.5-5.8 7.8c-.2.2-.5.4-.8.4c-.2 0-.4 0-.5-.1c-1.2-.5-1.4-1.1-1.2-2.3c.2-1 .5-2 1-2.9c.9-1.8 2.2-3.4 3.3-5.1c1.9-2.9 4.1-5.6 6.6-8c6.8-6.3 15.6-11.1 21.4-12.6z" fill="#ff8a80"></path>
      <path fill="#c33" d="M32.4 25.3l-2 2l71.1 71.1l1.8-2.2z"></path>
    </svg>
  );
}
// Componente para los controles del quiz
const QuizControls = ({ 
  comodines, 
  mostrarTemporizadorLlamada, 
  setMostrarTemporizadorLlamada,
  tiempoLlamada, 
  temporizadorLlamadaActivo, 
  setTemporizadorLlamadaActivo,
  setTiempoLlamada,
  mostrarGraficoPublico, 
  datosGraficoPublico, 
  tiempoRestantePublico, 
  setTiempoRestantePublico,
  votosPublico, 
  setVotosPublico,
  respuestasMezcladasPreguntaActual, 
  usarComodin, 
  preguntaActual, 
  respuestas, 
  respuestaRevelada, 
  respuestasVisibles,
  setRespuestasVisibles,
  setRespuestasEliminadas,
  setMostrarGraficoPublico,
  setTemporizadorPublicoActivo,
  twitchChatService,
  historialVotos,
  setHistorialVotos,
  pregunta, // Agregar la prop de la pregunta para mostrar la explicación
  preguntasAcertadas, 
  cambiarPreguntaMago,
  mostrarDialogoConfirmacion,
  setMostrarDialogoConfirmacion,
  onConfirmTerminar,
  puntuacion,
  totalPreguntas,
  fallos,
  onSobornoVisibleChange
}) => {
    // Estado para marcar si un comodín ya se gastó en la partida
    const [gastado, setGastado] = React.useState({ llamada: false, publico: false, cincuenta: false, mago: false });

    // Resetear el estado de gastado cuando los comodines vuelven a estar todos disponibles (reinicio de concurso)
    React.useEffect(() => {
      if (comodines.llamada === 1 && comodines.publico === 1 && comodines.cincuenta === 1 && comodines.mago === 1) {
        setGastado({ llamada: false, publico: false, cincuenta: false, mago: false });
      }
    }, [comodines.llamada, comodines.publico, comodines.cincuenta, comodines.mago]);
  // Estado para el modal de soborno y el tipo de comodín a reactivar
  const [sobornoAbierto, setSobornoAbierto] = React.useState(false);
  const [comodinPendiente, setComodinPendiente] = React.useState(null);

  // Reflejar la visibilidad del modal de soborno en el overlay de OBS (tiempo real)
  React.useEffect(() => {
    if (typeof onSobornoVisibleChange === 'function') {
      onSobornoVisibleChange(sobornoAbierto);
    }
  }, [sobornoAbierto, onSobornoVisibleChange]);
  const cincuentaUsadoPorPreguntaRef = React.useRef({});
  const handleIntentarComodin = (tipo) => {
    // Si el comodín está disponible, actívalo normalmente
    if (comodines[tipo] > 0) {
      if (tipo === 'mago') {
        // El mago requiere lógica especial: petición a backend y actualización de pregunta
        if (typeof cambiarPreguntaMago === 'function') {
          const seUso = usarComodin(
            tipo,
            respuestasVisibles,
            respuestaRevelada,
            preguntaActual,
            respuestas,
            respuestasMezcladasPreguntaActual,
            setRespuestasVisibles,
            setRespuestasEliminadas,
            false,
            { cambiarPregunta: cambiarPreguntaMago }
          );
          if (seUso) {
            setGastado(prev => ({ ...prev, [tipo]: true }));
          }
        }
        return;
      }
      const seUso = usarComodin(tipo, respuestasVisibles, respuestaRevelada, preguntaActual, respuestas, respuestasMezcladasPreguntaActual, setRespuestasVisibles, setRespuestasEliminadas);
      if (seUso) {
        setGastado(prev => ({ ...prev, [tipo]: true }));
      }
      if (seUso && tipo === 'cincuenta') {
        cincuentaUsadoPorPreguntaRef.current[preguntaActual] = true;
      }
      return;
    }
    // Si es 50/50 y ya se usó en esta pregunta, no mostrar modal ni permitir soborno
    if (tipo === 'cincuenta' && cincuentaUsadoPorPreguntaRef.current[preguntaActual]) {
      return;
    }
    // Si está gastado, abre el modal de soborno
    setComodinPendiente(tipo);
    setSobornoAbierto(true);
  };

  // Cuando el usuario confirma el soborno
  const handleConfirmarSoborno = () => {
    setSobornoAbierto(false);
    if (comodinPendiente) {
      const seUso = usarComodin(
        comodinPendiente,
        respuestasVisibles,
        respuestaRevelada,
        preguntaActual,
        respuestas,
        respuestasMezcladasPreguntaActual,
        setRespuestasVisibles,
        setRespuestasEliminadas,
        true,
        comodinPendiente === 'mago' ? { cambiarPregunta: cambiarPreguntaMago } : {}
      );
      if (seUso) {
        // Marcar el comodín como gastado para mostrar el SVG prohibido el resto de la partida
        setGastado(prev => ({ ...prev, [comodinPendiente]: true }));
        // Si es 50/50, marcar como usado en el ref local
        if (comodinPendiente === 'cincuenta') {
          cincuentaUsadoPorPreguntaRef.current[preguntaActual] = true;
        }
      }
      setComodinPendiente(null);
    }
  };
  // Resetear el ref local de 50/50 al cambiar de pregunta
  React.useEffect(() => {
    // Si cambia la pregunta, no está usado para la nueva
    cincuentaUsadoPorPreguntaRef.current[preguntaActual] = false;
  }, [preguntaActual]);

  // Cuando el usuario cancela el soborno
  const handleCancelarSoborno = () => {
    setSobornoAbierto(false);
    setComodinPendiente(null);
  };

  return (
    <div className="lg:w-1/3 bg-white rounded-lg shadow-md p-4 dark:bg-gray-800 dark:text-white transition-colors duration-300 flex flex-col gap-4 min-w-0">
      {/* Comodines */}
      <div className="flex flex-col items-center">
        <div className="flex justify-center space-x-4 mb-4">
          <div style={{position:'relative',display:'inline-block'}}>
            <button
              onClick={() => handleIntentarComodin('llamada')}
              disabled={respuestas[preguntaActual] !== null || respuestaRevelada || respuestasVisibles < 4}
              className={`p-3 rounded-full ${comodines.llamada > 0 ? 'bg-purple-600 hover:bg-purple-700' : 'bg-gray-400'} text-white disabled:opacity-50 disabled:cursor-not-allowed dark:bg-purple-700 dark:hover:bg-purple-800 transition-colors duration-300`}
              title="Llamada a un amigo"
            >
              <CallIcon className="w-6 h-6" />
            </button>
            {gastado.llamada && <ProhibidoSVG />}
          </div>
          <div style={{position:'relative',display:'inline-block'}}>
            <button
              onClick={() => handleIntentarComodin('publico')}
              disabled={respuestas[preguntaActual] !== null || respuestaRevelada || respuestasVisibles < 4}
              className={`p-3 rounded-full ${comodines.publico > 0 ? 'bg-orange-600 hover:bg-orange-700' : 'bg-gray-400'} text-white disabled:opacity-50 disabled:cursor-not-allowed dark:bg-orange-700 dark:hover:bg-orange-800 transition-colors duration-300`}
              title="Ayuda del público"
            >
              <PublicIcon className="w-6 h-6" />
            </button>
            {gastado.publico && <ProhibidoSVG />}
          </div>
          <div style={{position:'relative',display:'inline-block'}}>
            <button
              onClick={() => handleIntentarComodin('cincuenta')}
              disabled={respuestas[preguntaActual] !== null || respuestaRevelada || respuestasVisibles < 4}
              className={`p-3 rounded-full ${comodines.cincuenta > 0 ? 'bg-red-600 hover:bg-red-700' : 'bg-gray-400'} text-white disabled:opacity-50 disabled:cursor-not-allowed dark:bg-red-700 dark:hover:bg-red-800 transition-colors duration-300`}
              title="50/50"
            >
              <FiftyIcon className="w-6 h-6" />
            </button>
            {gastado.cincuenta && <ProhibidoSVG />}
          </div>
          {/* Botón del mago (a la derecha y con SVG prohibido por fuera del botón) */}
          <div style={{position:'relative',display:'inline-block'}}>
            <button
              onClick={() => handleIntentarComodin('mago')}
              disabled={
                respuestas[preguntaActual] !== null || respuestaRevelada || respuestasVisibles < 4 || comodines.mago <= 0 || (typeof preguntasAcertadas === 'number' && preguntasAcertadas < 4)
              }
              className={`p-3 rounded-full ${comodines.mago > 0 ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-400'} text-white disabled:opacity-50 disabled:cursor-not-allowed dark:bg-blue-700 dark:hover:bg-blue-800 transition-colors duration-300`}
              title="Cambia la pregunta"
              style={{position:'relative',zIndex:1}}
            >
              <WizardMagoIcon className="w-6 h-6" />
            </button>
            {/* Overlay prohibido con animación */}
            <ProhibidoMagoOverlay preguntasAcertadas={preguntasAcertadas} gastadoMago={gastado.mago} />
          </div>
        </div>

        {/* Modal de soborno embebido debajo de los botones */}
        <ModalSoborno open={sobornoAbierto} onClose={handleCancelarSoborno} onConfirm={handleConfirmarSoborno} />
        
        <div className="relative w-full h-0 z-20">
          <div className="absolute top-0 left-0 right-0">
            <ConfirmationDialog
              mostrarDialogoConfirmacion={mostrarDialogoConfirmacion}
              setMostrarDialogoConfirmacion={setMostrarDialogoConfirmacion}
              onConfirm={onConfirmTerminar}
              puntuacion={puntuacion}
              totalPreguntas={totalPreguntas}
              fallos={fallos}
              embedded
            />

            {/* Gráfico del comodín del público */}
            {mostrarGraficoPublico && (
              <div className="w-full p-3 bg-orange-100 border-2 border-orange-300 rounded-lg dark:bg-orange-900 dark:border-orange-700 overflow-hidden text-sm" style={{ maxHeight: '500px' }}>
                <div className="flex items-center justify-between mb-2">
                  <span className="font-medium text-black dark:text-orange-200">Ayuda del público:</span>
                  <span className="text-lg font-bold text-black dark:text-orange-200">{tiempoRestantePublico}s</span>
                </div>
                <div className="mt-2 flex justify-center overflow-hidden" style={{ maxHeight: '200px' }}>
                  <ChartPublico datos={datosGraficoPublico} tiempoRestante={tiempoRestantePublico} />
                </div>
                <div className="mt-3 grid grid-cols-2 gap-2 max-h-32 overflow-y-auto">
                  {(() => {
                    const opcionesConVotos = respuestasMezcladasPreguntaActual.map((respuesta, index) => {
                      const votos = votosPublico[index] || 0;
                      const porcentaje = datosGraficoPublico?.datasets?.[0]?.data?.[index] || 0;
                      return {
                        index,
                        respuesta,
                        votos,
                        porcentaje
                      };
                    });

                    const opcionesOrdenadas = [...opcionesConVotos].sort((a, b) => b.votos - a.votos);

                    return opcionesOrdenadas.map((opcion) => {
                      return (
                        <div key={opcion.index} className="flex items-center justify-between p-2 bg-white dark:bg-gray-700 rounded border-gray-200 dark:border-gray-600 text-xs">
                          <span className="font-medium">{['A)', 'B)', 'C)', 'D)'][opcion.index]} {opcion.respuesta.texto}</span>
                          <span className="ml-2 bg-orange-100 dark:bg-orange-800 px-2 py-1 rounded text-xs font-bold">{opcion.votos} votos ({opcion.porcentaje}%)</span>
                        </div>
                      );
                    });
                  })()}
                </div>
                <div className="flex flex-wrap gap-2 mt-2 justify-center overflow-hidden">
                  <button
                    onClick={() => {
                      setMostrarGraficoPublico(false);
                      setTemporizadorPublicoActivo(false);
                      setTiempoRestantePublico(60);
                      setHistorialVotos([]);
                      if (twitchChatService.current) {
                        twitchChatService.current.stopPolling();
                      }
                      setVotosPublico([0, 0, 0, 0]);
                      if (twitchChatService.current) {
                        const votosIniciales = { A: 0, B: 0, C: 0, D: 0 };
                        twitchChatService.current.setInitialVotes(votosIniciales);
                      }
                    }}
                    className="px-2 py-1 bg-red-500 hover:bg-red-600 text-white rounded transition-colors text-xs"
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        
        {/* Controles del temporizador de la llamada */}
        {mostrarTemporizadorLlamada && (
          <div className="w-full p-3 bg-blue-50 rounded-lg dark:bg-gray-700 text-sm">
            <div className="flex items-center justify-between mb-2">
              <span className="font-medium text-black dark:text-white">Temporizador de la llamada:</span>
              <span className="text-lg font-bold text-black dark:text-white">{tiempoLlamada}s</span>
            </div>
            <div className="flex flex-wrap gap-2 justify-center">
              <button
                onClick={() => setTemporizadorLlamadaActivo(!temporizadorLlamadaActivo)}
                className={`px-2 py-1 rounded ${temporizadorLlamadaActivo ? 'bg-yellow-500 hover:bg-yellow-600' : 'bg-green-500 hover:bg-green-600'} text-white transition-colors text-xs`}
              >
                <span className="inline-flex items-center gap-1.5">
                  {temporizadorLlamadaActivo ? <FaPause size={12} /> : <FaPlay size={12} />}
                  {temporizadorLlamadaActivo ? 'Pausar' : 'Iniciar'}
                </span>
              </button>
              <button
                onClick={() => {
                  setTemporizadorLlamadaActivo(false);
                  setTiempoLlamada(30);
                }}
                className="px-2 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded transition-colors text-xs"
              >
                <span className="inline-flex items-center gap-1.5">
                  <FaRotateRight size={12} />
                  Reiniciar
                </span>
              </button>
              <button
                onClick={() => {
                  setMostrarTemporizadorLlamada(false);
                }}
                className="px-2 py-1 bg-red-500 hover:bg-red-600 text-white rounded transition-colors text-xs"
              >
                <span className="inline-flex items-center gap-1.5">
                  <FaPhoneSlash size={12} />
                  Parar
                </span>
              </button>
            </div>
          </div>
        )}
        
      </div>
      
      {/* Explicación de la pregunta - se muestra a la derecha en el cuadro de comodines */}
      {respuestaRevelada && pregunta?.explicacion && (
        <div className="p-3 bg-blue-50 rounded-lg dark:bg-gray-700 dark:text-white transition-colors duration-300 text-sm flex-grow w-full mt-4">
          <h3 className="font-semibold mb-2 dark:text-white">Explicación:</h3>
          {pregunta.imagen_url && (
            <div className="mb-3 flex justify-center">
              <img 
                src={buildImageUrl(pregunta.imagen_url)}
                alt="Imagen explicativa"
                className="w-full max-w-sm h-auto max-h-44 object-contain rounded-lg shadow-md"
                onError={(e) => {
                  e.target.style.display = 'none';
                  console.error('Error al cargar la imagen:', pregunta.imagen_url);
                }}
              />
            </div>
          )}
          <p className="dark:text-white">{pregunta.explicacion}</p>
        </div>
      )}
    </div>
 );
}

// Overlay animado para el mago
function ProhibidoMagoOverlay({ preguntasAcertadas, gastadoMago }) {
  const [visible, setVisible] = useState(true);
  const [fade, setFade] = useState(false);
  const prevAciertos = useRef(preguntasAcertadas);

  // Mostrar overlay si menos de 4 aciertos o si el mago está gastado
  useEffect(() => {
    if (typeof preguntasAcertadas === 'number' && preguntasAcertadas < 4) {
      setVisible(true);
      setFade(false);
    } else if (typeof preguntasAcertadas === 'number' && preguntasAcertadas >= 4 && prevAciertos.current < 4) {
      // Se acaba de desbloquear: fade out
      setFade(true);
      setTimeout(() => setVisible(false), 400);
    } else if (gastadoMago) {
      setVisible(true);
      setFade(false);
    } else {
      setVisible(false);
      setFade(false);
    }
    prevAciertos.current = preguntasAcertadas;
  }, [preguntasAcertadas, gastadoMago]);

  if (!visible) return null;
  return (
    <span
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        transition: 'opacity 0.4s',
        opacity: fade ? 0 : 1,
      }}
    >
      <ProhibidoSVG />
    </span>
  );
}

export default QuizControls;
